<table #datatables [id]="elementId" class="table table-striped table-no-bordered table-hover" cellspacing="0"
  width="100%" style="width:100%">
  <thead>
    <tr>
      @for (col of headerCols; track col; let index = $index) {
        <th>{{ dataTable.headerRow[index] }}</th>
      }
      <th class="disabled-sorting text-right"></th>
    </tr>
  </thead>
  <tfoot>
    <tr>
      @for (col of headerCols; track col; let index = $index) {
        <th>{{ dataTable.footerRow[index] }}</th>
      }
      <th class="text-right"></th>
    </tr>
  </tfoot>
  <tbody>
    @for (row of dataTable.dataRows; track row) {
      <tr>
        @for (col of headerCols; track col; let index = $index) {
          <td>{{row[index]}}</td>
        }
        <td class="text-right">
          @for (action of rowActions; track action; let index = $index) {
            @if (action.condition && action.condition(row)) {
              <button mat-icon-button color="primary"
                class="btn btn-link btn-info btn-just-icon " (click)="action.handler($event, row)"><i
              class="material-icons">{{action.icon}}</i></button>
            }
          }
        </td>
      </tr>
    }
  </tbody>
</table>